import Moment from "moment/moment";
import _ from "lodash/lodash";
import UUID from "../../core/util/uuid";
import Resource from "./resource.model";
import Service from "./service.model";
import Customer from "./customer.model";
import Vehicle from "./vehicle.model";
import WheelStorage from "./wheelstorage.model";

export default class Booking {

    static SOURCE_APP = "source.neonis.app";

    constructor(data) {
        this.id = null;
        this.version = null;
        this.source = Booking.SOURCE_APP;
        this.creationDate = null;
        this.creator = null;
        this.startTime = null;
        this.endTime = null;
        this.title = null;
        this.description = null;
        this.message = null;
        this.textColor = null;
        this.backgroundColor = null;
        this.state = null;
        this.orderNumber = null;
        this.resource = null;
        this.service = null;
        this.additionalServices = [];
        this.customer = null;
        this.vehicle = null;
        this.storage = null;

        if (data) {
            Object.assign(this, data);

            if (this.resource) {
                this.resource = new Resource(this.resource);
            }

            if (this.service) {
                this.service = new Service(this.service);
            }

            if (this.additionalServices.length > 0) {
                this.additionalServices = this.additionalServices.map((serviceData) => {
                    return new Service(serviceData);
                });
            }

            if (this.customer) {
                this.customer = new Customer(this.customer);
            }

            if (this.vehicle) {
                this.vehicle = new Vehicle(this.vehicle);
            }

            if (this.storage) {
                this.storage = new WheelStorage(this.storage);
            }
        }
    }

    isOpen() {
        return this.state === 'open' && Moment(this.endTime).isAfter(Moment());
    }

    isFinished() {
        return this.state !== 'open' || Moment(this.endTime).isBefore(Moment());
    }

    isCancelled() {
        return this.state === 'cancelled' || this.state === 'rejected';
    }

    isActive(interval) {
        return this.isBetween(Moment(), Moment().add(interval || 5, 'minutes'));
    }

    isBetween(startTime, endTime) {
        if (Moment(this.startTime).isBefore(Moment(endTime))
            && Moment(this.endTime).isAfter(Moment(startTime))) {
            return true;

        } else {
            return false;
        }
    }

    get duration() {
        if (this._duration) {
            return this._duration;
        }

        var diff = Moment(this.endTime).diff(Moment(this.startTime), 'minutes');
        if (diff <= 60) {
            this._duration = diff + " Min";
        } else {
            if (diff % 60 === 0) {
                this._duration = Moment.duration(diff, 'minutes').format("h [Std]");
            } else {
                this._duration = Moment.duration(diff, 'minutes').format("h:mm [Std]");
            }
        }

        return this._duration;
    }

    set duration(duration) {
        // Ignored
    }

    static groupByNone(bookings) {
        return [{
            id: UUID(),
            type: 'none',
            title: null,
            bookings: bookings
        }]
    }

    static groupByActive(bookings, interval) {
        var grouped = {
            id: UUID(),
            type: 'active',
            title: 'Aktive',
            bookings: null
        };

        grouped.bookings = _(bookings)
            .filter(booking => booking.isActive(interval))
            .value();

        return [grouped];
    }

    static groupByHour(bookings) {
        return _(bookings)
            .groupBy(booking => Moment(booking.startTime).format('HH'))
            .map((groupedBookings, key) => {
                return {
                    id: UUID(),
                    type: 'hour',
                    title: key + ' Uhr',
                    bookings: groupedBookings
                }
            })
            .sortBy(group => group.title)
            .value();
    }

    static groupByDay(bookings) {
        return _(bookings)
            .groupBy(booking => Moment(booking.startTime).format('dddd DD.MM'))
            .map((groupedBookings, key) => {
                return {
                    id: UUID(),
                    type: 'day',
                    title: key,
                    bookings: groupedBookings
                }
            })
            .sortBy(group => group.bookings[0].startTime)
            .value();
    }

    static groupByResource(bookings) {
        return _(bookings)
            .groupBy(booking => booking.resource.name)
            .map((groupedBookings, key) => {
                return {
                    id: UUID(),
                    type: 'resource',
                    title: key,
                    bookings: groupedBookings
                }
            })
            .sortBy(group => group.title)
            .value();
    }

    static groupByService(bookings) {
        return _(bookings)
            .groupBy(booking => booking.service ? booking.service.name : 'ohne')
            .map((groupedBookings, key) => {
                return {
                    id: UUID(),
                    type: 'service',
                    title: key,
                    bookings: groupedBookings
                }
            })
            .sortBy(group => group.title)
            .value();
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/booking.model.js